import { useLocalization } from "@fluent/react";
import { Tooltip, ResponsiveFlex } from "@narmi/design_system";
import TransferFeesDialog from "../funds/TransferFeesDialog";
import useDeliverySpeedOptions from "./useDeliverySpeedOptions";
import SingleExpediteDeliverySpeedCards from "./SingleExpediteDeliverySpeedCards";
import styles from "./DeliverySpeedSection.module.scss";

const DeliverySpeedSection = () => {
  const { l10n } = useLocalization();
  const {
    options,
    selectedDeliverySpeed,
    setDeliverySpeed,
    instantFee,
    isPastCutoff,
    cutoffTime,
  } = useDeliverySpeedOptions();

  // nothing to choose between when only standard ACH is available
  const hasExpeditedOption = options.some((option) => option.expedite);
  if (!hasExpeditedOption) {
    return null;
  }

  return (
    <ResponsiveFlex gapSize="m">
      <div className={styles.deliverySpeedHeader}>
        <h4 className="fontSize--m nds-sans">
          {l10n.getString("header-delivery-speed")}{" "}
          <Tooltip
            text={l10n.getString("tooltip-scheduled-instant-unavailable")}
          >
            <span className="narmi-icon-info" />
          </Tooltip>
        </h4>
        <TransferFeesDialog fees={instantFee} />
      </div>
      <SingleExpediteDeliverySpeedCards
        options={options}
        selectedValue={selectedDeliverySpeed}
        onSelect={setDeliverySpeed}
      />
      {selectedDeliverySpeed === "sameDay" && cutoffTime ? (
        <div className="fontColor--secondary fontSize--s">
          {isPastCutoff
            ? l10n.getString("ach-payment-same-day-cutoff-passed", {
                cutoffTime,
              })
            : l10n.getString("ach-payment-cutoff-time", { cutoffTime })}
        </div>
      ) : null}
    </ResponsiveFlex>
  );
};

export default DeliverySpeedSection;
